/** Helper for displaying grid columns with margin */
export const GridColumns = (count: number) => `
  width: calc((100% - ${count - 1}% - 1px) / ${count});
  :not(:nth-child(${count}n)) {
    margin-right: 1%;
  }
`;
